export default function mediaHub ({ $config }, inject) {
  /* eslint-disable camelcase */

  // Builds media-hub IPX URLs for CMS assets. The CMS uploads bucket maps to
  // the `quero-cms-prod` backend. The legacy imageboss dialect (operation +
  // DPR) is translated to IPX modifiers (w_, h_, s_WxH,fit_cover); the old
  // imageboss `cdn` no-op becomes `_` (no IPX transform).
  const MEDIA_HUB_BASE = 'https://media-hub.quero.space'
  const MEDIA_HUB_BACKEND = 'quero-cms-prod'

  function mediaHubURL ({ modifiers, fileName }) {
    return `${MEDIA_HUB_BASE}/img/${modifiers}/${MEDIA_HUB_BACKEND}/uploads/${fileName}`
  }

  function fallbackImageURL () {
    return `${MEDIA_HUB_BASE}/img/fit_contain,f_webp,q_80/kong/og-querobolsa.png`
  }

  function getModifiers ({ operation, width, height, dpr }) {
    // Multiply requested dimensions by DPR so the actual served image is
    // physically large enough for a retina render. Round to integer.
    const w = typeof width === 'number' ? Math.round(width * dpr) : null
    const h = typeof height === 'number' ? Math.round(height * dpr) : null

    const builders = {
      width: () => `w_${w}`,
      height: () => `h_${h}`,
      cdn: () => '_',
      cover: () => `s_${w}x${h},fit_cover`,
    }

    return (builders[operation] || builders.cover)()
  }

  function getCdnImagePath (fileName) {
    return `${$config.cms.cdn}/uploads/${fileName}`
  }

  function getAssetURL (src, options = {}) {
    if (!src) return fallbackImageURL()

    const {
      storage,
      filename_disk,
      width: srcWidth,
      height: srcHeight,
    } = src

    if (!filename_disk) return null

    if ($config.ENVIRONMENT === 'development') return `${$config.cms.cdn}/assets/${filename_disk}`

    if (storage !== 'aws') return getCdnImagePath(filename_disk)

    const [hash, ext] = filename_disk.split('.')

    if (ext === 'svg') return getCdnImagePath(filename_disk)

    const {
      dpr = 1,
      operation = 'cover',
      width: operationWidth,
      height: operationHeight,
    } = options

    const [width, height] = [operationWidth || srcWidth, operationHeight || srcHeight]
    const fileName = `${hash}.${ext}`
    const modifiers = getModifiers({ operation, width, height, dpr })

    return mediaHubURL({ modifiers, fileName })
  }

  inject('mediaHub', getAssetURL)

  return getAssetURL
}
